
export const  ActionButton = ()=>({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "32px",
    gap: "8px",
    p: "8px",
    borderRadius: "8px",
})